import notify from 'devextreme/ui/notify';
import store from '../store'

import {
    request
} from '../request/axios.request';

import {
    errorCommon
} from './error.common'

function getNotOverDesiredShifts() {
    return request({
        baseURL: process.env.VUE_APP_BASE_API_URL_SHIFT_PLAN,
        responseType: 'json',
        url: '/api/v2/WorkerShiftApi/GetNotOverDesiredShifts',
        method: 'get',
        handleRequest,
        handleResponse
    }).then(res => {
        console.log(res)
        if (res.status == 200) {
            return res.data;
        } else {
            notify("GetNotOverDesiredShifts Failed !");
        }
    }).catch(err => {

        errorCommon.showError(err);

        return Promise.reject(err.message);
    });
}

function getWorkerShifts(workingDayFrom, workingDayTo) {
    return request({
        baseURL: process.env.VUE_APP_BASE_API_URL_SHIFT_PLAN,
        responseType: 'json',
        url: '/api/v2/WorkerShiftApi/GetWorkerShifts',
        method: 'get',
        params: {
            "WorkingDayFrom": workingDayFrom,
            "WorkingDayTo": workingDayTo,
        },
        handleRequest,
        handleResponse
    }).then(res => {
        console.log(res)
        if (res.status == 200) {
            return res.data;
        } else {
            notify("GetWorkerShifts Failed !");
        }
    }).catch(err => {

        errorCommon.showError(err);

        return Promise.reject(err.message);
    });
}

function getOfficeShiftChangeJob(workDate) {
    return request({
        baseURL: process.env.VUE_APP_BASE_API_URL_SHIFT_PLAN,
        responseType: 'json',
        url: '/api/v2/OfficeShiftChangeJobApi/GetOfficeShiftChangeJob',
        method: 'get',
        params: {
            "WorkDate": workDate,
        },
        handleRequest,
        handleResponse
    }).then(res => {
        console.log(res)
        if (res.status == 200) {
            return res.data;
        } else {
            notify("GetOfficeShiftChangeJob Failed !");
        }
    }).catch(err => {

        errorCommon.showError(err);

        return Promise.reject(err.message);
    });
}

function replyOfficeShiftChangeJob(workerShift, officeShiftChangeWorker) {
    return request({
        baseURL: process.env.VUE_APP_BASE_API_URL_SHIFT_PLAN,
        responseType: 'json',
        url: '/api/v2/OfficeShiftChangeJobApi/ReplyOfficeShiftChangeJob',
        method: 'post',
        data: {
            "OfficeShiftChangeWorker": officeShiftChangeWorker,
            "WorkerShift": workerShift,
            "UpdateUserId": parseInt(store.state.constantAppUpdateUserId)
        },
        handleRequest,
        handleResponse
    }).then(res => {
        console.log(res)
        if (res.status == 200) {
            return res.data;
        } else {
            notify("ReplyOfficeShiftChangeJob Failed !");
        }
    }).catch(err => {

        errorCommon.showError(err);

        return Promise.reject(err.message);
    });
}

function confirmOfficeShiftChangeJob(workerShift, officeShiftChangeWorker) {
    return request({
        baseURL: process.env.VUE_APP_BASE_API_URL_SHIFT_PLAN,
        responseType: 'json',
        url: '/api/v2/OfficeShiftChangeJobApi/ConfirmOfficeShiftChangeJob',
        method: 'post',
        data: {
            "OfficeShiftChangeWorker": officeShiftChangeWorker,
            "WorkerShift": workerShift,
            "UpdateUserId": parseInt(store.state.constantAppUpdateUserId)
        },
        handleRequest,
        handleResponse
    }).then(res => {
        console.log(res)
        if (res.status == 200) {
            return res.data;
        } else {
            notify("ConfirmOfficeShiftChangeJob Failed !");
        }
    }).catch(err => {

        errorCommon.showError(err);

        return Promise.reject(err.message);
    });
}

function getWorkerShiftChange(workDate) {
    return request({
        baseURL: process.env.VUE_APP_BASE_API_URL_SHIFT_PLAN,
        responseType: 'json',
        url: '/api/v2/WorkerShiftChangeApi/GetWorkerShiftChange',
        method: 'get',
        params: {
            "WorkDate": workDate,
        },
        handleRequest,
        handleResponse
    }).then(res => {
        console.log(res)
        if (res.status == 200) {
            return res.data;
        } else {
            notify("GetWorkerShiftChange Failed !");
        }
    }).catch(err => {

        errorCommon.showError(err);

        return Promise.reject(err.message);
    });
}

function getAfterConfirmShifts(workingDay) {
    return request({
        baseURL: process.env.VUE_APP_BASE_API_URL_SHIFT_PLAN,
        responseType: 'json',
        url: '/api/v2/WorkerShiftApi/GetAfterConfirmShifts',
        method: 'get',
        params: {
            'WorkingDay': workingDay,
        },
        handleRequest,
        handleResponse
    }).then(res => {
        console.log(res)
        if (res.status == 200) {
            return res.data;
        } else {
            notify("GetAfterConfirmShifts Failed !");
        }
    }).catch(err => {

        errorCommon.showError(err);

        return Promise.reject(err.message);
    });
}

function createWorkerShiftChange(workerShift, workerShiftChange) {
    return request({
        baseURL: process.env.VUE_APP_BASE_API_URL_SHIFT_PLAN,
        responseType: 'json',
        url: '/api/v2/WorkerShiftChangeApi/CreateWorkerShiftChange',
        method: 'post',
        data: {
            "WorkerShift": workerShift,
            "WorkerShiftChange": workerShiftChange,
            "UpdateUserId": parseInt(store.state.constantAppUpdateUserId)
        },
        handleRequest,
        handleResponse
    }).then(res => {
        console.log(res)
        if (res.status == 200) {
            return res.data;
        } else {
            notify("CreateWorkerShiftChange Failed !");
        }
    }).catch(err => {

        errorCommon.showError(err);

        return Promise.reject(err.message);
    });
}

function cancelWorkerShiftChange(workerShift, workerShiftChange) {
    return request({
        baseURL: process.env.VUE_APP_BASE_API_URL_SHIFT_PLAN,
        responseType: 'json',
        url: '/api/v2/WorkerShiftChangeApi/CancelWorkerShiftChange',
        method: 'post',
        data: {
            "WorkerShift": workerShift,
            "WorkerShiftChange": workerShiftChange,
            "UpdateUserId": parseInt(store.state.constantAppUpdateUserId)
        },
        handleRequest,
        handleResponse
    }).then(res => {
        console.log(res)
        if (res.status == 200) {
            return res.data;
        } else {
            notify("CancelWorkerShiftChange Failed !");
        }
    }).catch(err => {

        errorCommon.showError(err);

        return Promise.reject(err.message);
    });
}

function confirmWorkerShiftChange(workerShift, workerShiftChange) {
    return request({
        baseURL: process.env.VUE_APP_BASE_API_URL_SHIFT_PLAN,
        responseType: 'json',
        url: '/api/v2/WorkerShiftChangeApi/ConfirmWorkerShiftChange',
        method: 'post',
        data: {
            "WorkerShift": workerShift,
            "WorkerShiftChange": workerShiftChange,
            "UpdateUserId": parseInt(store.state.constantAppUpdateUserId)
        },
        handleRequest,
        handleResponse
    }).then(res => {
        console.log(res)
        if (res.status == 200) {
            return res.data;
        } else {
            notify("ConfirmWorkerShiftChange Failed !");
        }
    }).catch(err => {

        errorCommon.showError(err);

        return Promise.reject(err.message);
    });
}

function submitDesiredShifts(workerShifts, desiredShiftWorkers) {
    return request({
        baseURL: process.env.VUE_APP_BASE_API_URL_SHIFT_PLAN,
        responseType: 'json',
        url: '/api/v2/WorkerShiftApi/SubmitDesiredShifts',
        method: 'post',
        data: {
            "DesiredShiftWorkers": desiredShiftWorkers,
            "WorkerShifts": workerShifts,
            "UpdateUserId": parseInt(store.state.constantAppUpdateUserId)
        },
        handleRequest,
        handleResponse
    }).then(res => {
        console.log(res)
        if (res.status == 200) {
            return res.data;
        } else {
            notify("SubmitDesiredShifts Failed !");
        }
    }).catch(err => {

        errorCommon.showError(err);

        return Promise.reject(err.message);
    });
}

function confirmDesiredShifts(workerShifts) {
    return request({
        baseURL: process.env.VUE_APP_BASE_API_URL_SHIFT_PLAN,
        responseType: 'json',
        url: '/api/v2/WorkerShiftApi/ConfirmDesiredShifts',
        method: 'post',
        data: {
            "WorkerShifts": workerShifts,
            "UpdateUserId": parseInt(store.state.constantAppUpdateUserId)
        },
        handleRequest,
        handleResponse
    }).then(res => {
        console.log(res)
        if (res.status == 200) {
            return res.data;
        } else {
            notify("ConfirmDesiredShifts Failed !");
        }
    }).catch(err => {

        errorCommon.showError(err);

        return Promise.reject(err.message);
    });
}

function handleRequest(config) {

    //リクエスト送信する前に、実行したい処理をここに書く
    let url = config.url;

    if (url.indexOf("login") == -1) {

        config.headers.Authorization = 'Bearer ' + store.state.token;
    }

    return config;
}

function handleResponse() {
    //レスポンス受信したときに、実行したい処理をここに書く
}

export const shiftPlanService = {
    getNotOverDesiredShifts,
    getWorkerShifts,
    getOfficeShiftChangeJob,
    replyOfficeShiftChangeJob,
    confirmOfficeShiftChangeJob,
    getWorkerShiftChange,
    getAfterConfirmShifts,
    createWorkerShiftChange,
    cancelWorkerShiftChange,
    confirmWorkerShiftChange,
    submitDesiredShifts,
    confirmDesiredShifts,
};